/* @ngInject */
export default function ($sce) {
	return $sce.trustAsHtml;
};


// WEBPACK FOOTER //
// ./src/js/filters/safeHtml.js